import { FC } from "react";
import useStyles from "../../../lead/quote/leadEstimateStyle";
import StorageContractForm from "./storageContractForm";

interface StorageContractProps {
  show: boolean;
  setShow: (show: boolean) => void;
}

const StorageContract: FC<StorageContractProps> = ({ show, setShow }) => {
  const classes = useStyles({ show });

  return (
    <>
      {show && (
        <section className={show ? classes.estimatePopupOverlay : ""}>
          <StorageContractForm
            show={false}
            setShow={setShow}
            screenType={"Storage Contract"}
          />
        </section>
      )}
    </>
  );
};

export default StorageContract;
